(() => {
  var e = {
    377: e => {
      ! function (t, n) {
        var r = function (e, t, n) {
          "use strict";
          var r, a;
          if (function () {
            var t, n = {
              lazyClass: "lazyload",
              loadedClass: "lazyloaded",
              loadingClass: "lazyloading",
              preloadClass: "lazypreload",
              errorClass: "lazyerror",
              autosizesClass: "lazyautosizes",
              fastLoadedClass: "ls-is-cached",
              iframeLoadMode: 0,
              srcAttr: "data-src",
              srcsetAttr: "data-srcset",
              sizesAttr: "data-sizes",
              minSize: 40,
              customMedia: {},
              init: !0,
              expFactor: 1.5,
              hFac: .8,
              loadMode: 2,
              loadHidden: !0,
              ricTimeout: 0,
              throttleDelay: 125
            };
            for (t in a = e.lazySizesConfig || e.lazysizesConfig || {}, n) t in a || (a[t] = n[t])
          }(), !t || !t.getElementsByClassName) return {
            init: function () { },
            cfg: a,
            noSupport: !0
          };
          var o = t.documentElement,
            i = e.HTMLPictureElement,
            s = "addEventListener",
            l = "getAttribute",
            d = e[s].bind(e),
            c = e.setTimeout,
            u = e.requestAnimationFrame || c,
            f = e.requestIdleCallback,
            h = /^picture$/i,
            m = ["load", "error", "lazyincluded", "_lazyloaded"],
            p = {},
            b = Array.prototype.forEach,
            y = function (e, t) {
              return p[t] || (p[t] = new RegExp("(\\s|^)" + t + "(\\s|$)")), p[t].test(e[l]("class") || "") && p[t]
            },
            g = function (e, t) {
              y(e, t) || e.setAttribute("class", (e[l]("class") || "").trim() + " " + t)
            },
            v = function (e, t) {
              var n;
              (n = y(e, t)) && e.setAttribute("class", (e[l]("class") || "").replace(n, " "))
            },
            z = function (e, t, n) {
              var r = n ? s : "removeEventListener";
              n && z(e, t), m.forEach((function (n) {
                e[r](n, t)
              }))
            },
            w = function (e, n, a, o, i) {
              var s = t.createEvent("Event");
              return a || (a = {}), a.instance = r, s.initEvent(n, !o, !i), s.detail = a, e.dispatchEvent(s), s
            },
            C = function (t, n) {
              var r;
              !i && (r = e.picturefill || a.pf) ? (n && n.src && !t[l]("srcset") && t.setAttribute("srcset", n.src), r({
                reevaluate: !0,
                elements: [t]
              })) : n && n.src && (t.src = n.src)
            },
            E = function (e, t) {
              return (getComputedStyle(e, null) || {})[t]
            },
            A = function (e, t, n) {
              for (n = n || e.offsetWidth; n < a.minSize && t && !e._lazysizesWidth;) n = t.offsetWidth, t = t.parentNode;
              return n
            },
            _ = function () {
              var e, n, r = [],
                a = [],
                o = r,
                i = function () {
                  var t = o;
                  for (o = r.length ? a : r, e = !0, n = !1; t.length;) t.shift()();
                  e = !1
                },
                s = function (r, a) {
                  e && !a ? r.apply(this, arguments) : (o.push(r), n || (n = !0, (t.hidden ? c : u)(i)))
                };
              return s._lsFlush = i, s
            }(),
            k = function (e, t) {
              return t ? function () {
                _(e)
              } : function () {
                var t = this,
                  n = arguments;
                _((function () {
                  e.apply(t, n)
                }))
              }
            },
            T = function (e) {
              var t, r = 0,
                o = a.throttleDelay,
                i = a.ricTimeout,
                s = function () {
                  t = !1, r = n.now(), e()
                },
                l = f && i > 49 ? function () {
                  f(s, {
                    timeout: i
                  }), i !== a.ricTimeout && (i = a.ricTimeout)
                } : k((function () {
                  c(s)
                }), !0);
              return function (e) {
                var a;
                (e = !0 === e) && (i = 33), t || (t = !0, (a = o - (n.now() - r)) < 0 && (a = 0), e || a < 9 ? l() : c(l, a))
              }
            },
            M = function (e) {
              var t, r, a = 99,
                o = function () {
                  t = null, e()
                },
                i = function () {
                  var e = n.now() - r;
                  e < a ? c(i, a - e) : (f || o)(o)
                };
              return function () {
                r = n.now(), t || (t = c(i, a))
              }
            },
            O = function () {
              var i, f, m, p, A, O, N, j, S, P, x, U, F = /^img$/i,
                W = /^iframe$/i,
                $ = "onscroll" in e && !/(gle|ing)bot/.test(navigator.userAgent),
                H = 0,
                B = 0,
                D = 0,
                q = -1,
                R = function (e) {
                  D--, (!e || D < 0 || !e.target) && (D = 0)
                },
                I = function (e) {
                  return null == U && (U = "hidden" == E(t.body, "visibility")), U || !("hidden" == E(e.parentNode, "visibility") && "hidden" == E(e, "visibility"))
                },
                V = function (e, n) {
                  var r, a = e,
                    i = I(e);
                  for (j -= n, x += n, S -= n, P += n; i && (a = a.offsetParent) && a != t.body && a != o;)(i = (E(a, "opacity") || 1) > 0) && "visible" != E(a, "overflow") && (r = a.getBoundingClientRect(), i = P > r.left && S < r.right && x > r.top - 1 && j < r.bottom + 1);
                  return i
                },
                Y = function () {
                  var e, n, s, d, c, u, h, m, b, y, g, v, z = r.elements;
                  if ((p = a.loadMode) && D < 8 && (e = z.length)) {
                    for (n = 0, q++; n < e; n++)
                      if (z[n] && !z[n]._lazyRace)
                        if (!$ || r.prematureUnveil && r.prematureUnveil(z[n])) te(z[n]);
                        else if ((m = z[n][l]("data-expand")) && (u = 1 * m) || (u = B), y || (y = !a.expand || a.expand < 1 ? o.clientHeight > 500 && o.clientWidth > 500 ? 500 : 370 : a.expand, r._defEx = y, g = y * a.expFactor, v = a.hFac, U = null, B < g && D < 1 && q > 2 && p > 2 && !t.hidden ? (B = g, q = 0) : B = p > 1 && q > 1 && D < 6 ? y : H), b !== u && (O = innerWidth + u * v, N = innerHeight + u, h = -1 * u, b = u), s = z[n].getBoundingClientRect(), (x = s.bottom) >= h && (j = s.top) <= N && (P = s.right) >= h * v && (S = s.left) <= O && (x || P || S || j) && (a.loadHidden || I(z[n])) && (f && D < 3 && !m && (p < 3 || q < 4) || V(z[n], u))) {
                          if (te(z[n]), c = !0, D > 9) break
                        } else !c && f && !d && D < 4 && q < 4 && p > 2 && (i[0] || a.preloadAfterLoad) && (i[0] || !m && (x || P || S || j || "auto" != z[n][l](a.sizesAttr))) && (d = i[0] || z[n]);
                    d && !c && te(d)
                  }
                },
                J = T(Y),
                K = function (e) {
                  var t = e.target;
                  t._lazyCache ? delete t._lazyCache : (R(e), g(t, a.loadedClass), v(t, a.loadingClass), z(t, Q), w(t, "lazyloaded"))
                },
                G = k(K),
                Q = function (e) {
                  G({
                    target: e.target
                  })
                },
                X = function (e, t) {
                  var n = e.getAttribute("data-load-mode") || a.iframeLoadMode;
                  0 == n ? e.contentWindow.location.replace(t) : 1 == n && (e.src = t)
                },
                Z = function (e) {
                  var t, n = e[l](a.srcsetAttr);
                  (t = a.customMedia[e[l]("data-media") || e[l]("media")]) && e.setAttribute("media", t), n && e.setAttribute("srcset", n)
                },
                ee = k((function (e, t, n, r, o) {
                  var i, s, d, u, f, p;
                  (f = w(e, "lazybeforeunveil", t)).defaultPrevented || (r && (n ? g(e, a.autosizesClass) : e.setAttribute("sizes", r)), s = e[l](a.srcsetAttr), i = e[l](a.srcAttr), o && (u = (d = e.parentNode) && h.test(d.nodeName || "")), p = t.firesLoad || "src" in e && (s || i || u), f = {
                    target: e
                  }, g(e, a.loadingClass), p && (clearTimeout(m), m = c(R, 2500), z(e, Q, !0)), u && b.call(d.getElementsByTagName("source"), Z), s ? e.setAttribute("srcset", s) : i && !u && (W.test(e.nodeName) ? X(e, i) : e.src = i), o && (s || u) && C(e, {
                    src: i
                  })), e._lazyRace && delete e._lazyRace, v(e, a.lazyClass), _((function () {
                    var t = e.complete && e.naturalWidth > 1;
                    p && !t || (t && g(e, a.fastLoadedClass), K(f), e._lazyCache = !0, c((function () {
                      "_lazyCache" in e && delete e._lazyCache
                    }), 9)), "lazy" == e.loading && D--
                  }), !0)
                })),
                te = function (e) {
                  if (!e._lazyRace) {
                    var t, n = F.test(e.nodeName),
                      r = n && (e[l](a.sizesAttr) || e[l]("sizes")),
                      o = "auto" == r;
                    (!o && f || !n || !e[l]("src") && !e.srcset || e.complete || y(e, a.errorClass) || !y(e, a.lazyClass)) && (t = w(e, "lazyunveilread").detail, o && L.updateElem(e, !0, e.offsetWidth), e._lazyRace = !0, D++, ee(e, t, o, r, n))
                  }
                },
                ne = M((function () {
                  a.loadMode = 3, J()
                })),
                re = function () {
                  3 == a.loadMode && (a.loadMode = 2), ne()
                },
                ae = function () {
                  f || (n.now() - A < 999 ? c(ae, 999) : (f = !0, a.loadMode = 3, J(), d("scroll", re, !0)))
                };
              return {
                _: function () {
                  A = n.now(), r.elements = t.getElementsByClassName(a.lazyClass), i = t.getElementsByClassName(a.lazyClass + " " + a.preloadClass), d("scroll", J, !0), d("resize", J, !0), d("pageshow", (function (e) {
                    if (e.persisted) {
                      var n = t.querySelectorAll("." + a.loadingClass);
                      n.length && n.forEach && u((function () {
                        n.forEach((function (e) {
                          e.complete && te(e)
                        }))
                      }))
                    }
                  })), e.MutationObserver ? new MutationObserver(J).observe(o, {
                    childList: !0,
                    subtree: !0,
                    attributes: !0
                  }) : (o[s]("DOMNodeInserted", J, !0), o[s]("DOMAttrModified", J, !0), setInterval(J, 999)), d("hashchange", J, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend"].forEach((function (e) {
                    t[s](e, J, !0)
                  })), /d$|^c/.test(t.readyState) ? ae() : (d("load", ae), t[s]("DOMContentLoaded", J), c(ae, 2e4)), r.elements.length ? (Y(), _._lsFlush()) : J()
                },
                checkElems: J,
                unveil: te,
                _aLSL: re
              }
            }(),
            L = function () {
              var e, n = k((function (e, t, n, r) {
                var a, o, i;
                if (e._lazysizesWidth = r, r += "px", e.setAttribute("sizes", r), h.test(t.nodeName || ""))
                  for (o = 0, i = (a = t.getElementsByTagName("source")).length; o < i; o++) a[o].setAttribute("sizes", r);
                n.detail.dataAttr || C(e, n.detail)
              })),
                r = function (e, t, r) {
                  var a, o = e.parentNode;
                  o && (r = A(e, o, r), (a = w(e, "lazybeforesizes", {
                    width: r,
                    dataAttr: !!t
                  })).defaultPrevented || (r = a.detail.width) && r !== e._lazysizesWidth && n(e, o, a, r))
                },
                o = M((function () {
                  var t, n = e.length;
                  if (n)
                    for (t = 0; t < n; t++) r(e[t])
                }));
              return {
                _: function () {
                  e = t.getElementsByClassName(a.autosizesClass), d("resize", o)
                },
                checkElems: o,
                updateElem: r
              }
            }(),
            N = function () {
              !N.i && t.getElementsByClassName && (N.i = !0, L._(), O._())
            };
          return c((function () {
            a.init && N()
          })), r = {
            cfg: a,
            autoSizer: L,
            loader: O,
            init: N,
            uP: C,
            aC: g,
            rC: v,
            hC: y,
            fire: w,
            gW: A,
            rAF: _
          }
        }(t, t.document, Date);
        t.lazySizes = r, e.exports && (e.exports = r)
      }("undefined" != typeof window ? window : {})
    },
    4412: (e, t, n) => {
      "use strict";

      function r(e, t = document) {
        return t.querySelector(e)
      }

      function a(e, t = document) {
        return Array.from(t.querySelectorAll(e))
      }

      function o({
        type: e,
        props: t = {}
      }) {
        const n = document.createElement(e),
          r = e => e.startsWith("on"),
          {
            innerHTML: a,
            ...o
          } = t;
        return Object.keys(o).forEach((e => {
          (e => !r(e) && "children" !== e)(e) && (n[e] = t[e]), r(e) && n.addEventListener(e.toLowerCase().slice(2), t[e], !1)
        })), a && n.insertAdjacentHTML("afterbegin", a), t.children?.forEach((e => i(e, n))), n
      }

      function i(e, t) {
        Array.isArray(e) || (e = [e]), t.append(...e.map((e => o(e))))
      }
      n.d(t, {
        U2: () => r,
        az: () => o,
        go: () => a,
        lw: () => i
      })
    },
    9394: (e, t, n) => {
      "use strict";
      n.d(t, {
        $e: () => r
      });
      const r = "requestIdleCallback" in window ? requestIdleCallback : setTimeout
    },
    4824: (e, t, n) => {
      n.p = window.Shopify.cdnAssetsPath
    },
    2092: (e, t, n) => {
      var r = {
        "./theme": [774, 505],
        "./theme.ts": [774, 505]
      };

      function a(e) {
        if (!n.o(r, e)) return Promise.resolve().then((() => {
          var t = new Error("Cannot find module '" + e + "'");
          throw t.code = "MODULE_NOT_FOUND", t
        }));
        var t = r[e],
          a = t[0];
        return n.e(t[1]).then((() => n(a)))
      }
      a.keys = () => Object.keys(r), a.id = 2092, e.exports = a
    },
    8131: (e, t, n) => {
      var r = {
        "./HTML5": [7351, 120],
        "./HTML5.ts": [7351, 120],
        "./Vimeo": [4633, 637],
        "./Vimeo.ts": [4633, 637],
        "./YouTube": [6140, 774],
        "./YouTube.ts": [6140, 774]
      };

      function a(e) {
        if (!n.o(r, e)) return Promise.resolve().then((() => {
          var t = new Error("Cannot find module '" + e + "'");
          throw t.code = "MODULE_NOT_FOUND", t
        }));
        var t = r[e],
          a = t[0];
        return n.e(t[1]).then((() => n(a)))
      }
      a.keys = () => Object.keys(r), a.id = 8131, e.exports = a
    }
  },
    t = {};

  function n(r) {
    var a = t[r];
    if (void 0 !== a) return a.exports;
    var o = t[r] = {
      exports: {}
    };
    return e[r](o, o.exports, n), o.exports
  }
  n.m = e, n.n = e => {
    var t = e && e.__esModule ? () => e.default : () => e;
    return n.d(t, {
      a: t
    }), t
  }, (() => {
    var e, t = Object.getPrototypeOf ? e => Object.getPrototypeOf(e) : e => e.__proto__;
    n.t = function (r, a) {
      if (1 & a && (r = this(r)), 8 & a) return r;
      if ("object" == typeof r && r) {
        if (4 & a && r.__esModule) return r;
        if (16 & a && "function" == typeof r.then) return r
      }
      var o = Object.create(null);
      n.r(o);
      var i = {};
      e = e || [null, t({}), t([]), t(t)];
      for (var s = 2 & a && r;
        "object" == typeof s && !~e.indexOf(s); s = t(s)) Object.getOwnPropertyNames(s).forEach((e => i[e] = () => r[e]));
      return i.default = () => r, n.d(o, i), o
    }
  })(), n.d = (e, t) => {
    for (var r in t) n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, {
      enumerable: !0,
      get: t[r]
    })
  }, n.f = {}, n.e = e => Promise.all(Object.keys(n.f).reduce(((t, r) => (n.f[r](e, t), t)), [])), n.k = e => "assets/" + {
    19: "header",
    120: "HTML5",
    209: "accordion",
    226: "propify-dialog",
    280: "slider-autoplay",
    309: "slider",
    393: "vimeo-player",
    407: "slider-arrows",
    436: "body-scroll-lock",
    460: "product-personalization",
    505: "theme",
    520: "tabs",
    532: "product-form",
    619: "slider-thumbnails",
    628: "smooth-scroll",
    637: "Vimeo",
    642: "lite-vimeo",
    647: "lib",
    703: "mini-basket",
    718: "react-instant-search",
    722: "slider-tabs",
    774: "YouTube",
    789: "slider-dots",
    832: "header-landing",
    835: "customer-addresses",
    869: "slider-progressbar",
    900: "product-popup",
    928: "framework",
    969: "product-variant-radios"
  }[e] + "." + {}[e] + ".css", n.u = e => "assets/" + {
    19: "header",
    120: "HTML5",
    209: "accordion",
    226: "propify-dialog",
    280: "slider-autoplay",
    309: "slider",
    393: "vimeo-player",
    407: "slider-arrows",
    436: "body-scroll-lock",
    460: "product-personalization",
    505: "theme",
    520: "tabs",
    532: "product-form",
    619: "slider-thumbnails",
    628: "smooth-scroll",
    637: "Vimeo",
    642: "lite-vimeo",
    647: "lib",
    703: "mini-basket",
    718: "react-instant-search",
    722: "slider-tabs",
    774: "YouTube",
    789: "slider-dots",
    832: "header-landing",
    835: "customer-addresses",
    869: "slider-progressbar",
    900: "product-popup",
    928: "framework",
    969: "product-variant-radios"
  }[e] + "." + {
    19: "b27d7a68df64f273",
    120: "48da01b9ea215e3f",
    209: "07296767dfa91dbb",
    226: "181ea281df2893f4",
    280: "98b1bad808c1d5bb",
    309: "0c15163b7270839e",
    393: "71eaccf3c1266de8",
    407: "700f2672ae6ad840",
    436: "e248eb0c71ce8544",
    460: "06c9c5f89e503025",
    505: "46d63d323bf2c47b",
    520: "ada8c17501c97c18",
    532: "2986a40eeec71eb2",
    619: "66c548eb49098f21",
    628: "c713eaeb965ad05c",
    637: "d80d52401b8545f8",
    642: "23e9bb1a3cc28c40",
    647: "d898b9e35f550b7e",
    703: "39586463c260a135",
    718: "3521ff3da65a8d45",
    722: "4f2c756d1e4d8627",
    774: "a33416f309e75540",
    789: "8ee93436aa71980e",
    832: "acc31de83ef0316a",
    835: "313ea8aae96284a2",
    869: "24855ca7fb6220b4",
    900: "50af8b76583a4574",
    928: "5ee76e013b0a21e8",
    969: "cb49df9a80d16f06"
  }[e] + ".js?v=" + window.themeVersion, n.miniCssF = e => "assets/" + {
    226: "propify-dialog",
    703: "mini-basket",
    718: "react-instant-search"
  }[e] + "." + {
    226: "6abb5d2bc4866ded",
    703: "5431bd9f76d50d16",
    718: "a2c76f24d7dd48c3"
  }[e] + ".css", n.g = function () {
    if ("object" == typeof globalThis) return globalThis;
    try {
      return this || new Function("return this")()
    } catch (e) {
      if ("object" == typeof window) return window
    }
  }(), n.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), (() => {
    var e = {},
      t = "demel-shopify-template:";
    n.l = (r, a, o, i) => {
      if (e[r]) e[r].push(a);
      else {
        var s, l;
        if (void 0 !== o)
          for (var d = document.getElementsByTagName("script"), c = 0; c < d.length; c++) {
            var u = d[c];
            if (u.getAttribute("src") == r || u.getAttribute("data-webpack") == t + o) {
              s = u;
              break
            }
          }
        s || (l = !0, (s = document.createElement("script")).charset = "utf-8", s.timeout = 120, n.nc && s.setAttribute("nonce", n.nc), s.setAttribute("data-webpack", t + o), s.src = r), e[r] = [a];
        var f = (t, n) => {
          s.onerror = s.onload = null, clearTimeout(h);
          var a = e[r];
          if (delete e[r], s.parentNode && s.parentNode.removeChild(s), a && a.forEach((e => e(n))), t) return t(n)
        },
          h = setTimeout(f.bind(null, void 0, {
            type: "timeout",
            target: s
          }), 12e4);
        s.onerror = f.bind(null, s.onerror), s.onload = f.bind(null, s.onload), l && document.head.appendChild(s)
      }
    }
  })(), n.r = e => {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    })
  }, n.p = "", (() => {
    var e = e => new Promise(((t, r) => {
      var a = n.miniCssF(e),
        o = n.p + a;
      if (((e, t) => {
        for (var n = document.getElementsByTagName("link"), r = 0; r < n.length; r++) {
          var a = (i = n[r]).getAttribute("data-href") || i.getAttribute("href");
          if ("stylesheet" === i.rel && (a === e || a === t)) return i
        }
        var o = document.getElementsByTagName("style");
        for (r = 0; r < o.length; r++) {
          var i;
          if ((a = (i = o[r]).getAttribute("data-href")) === e || a === t) return i
        }
      })(a, o)) return t();
      ((e, t, n, r) => {
        var a = document.createElement("link");
        a.rel = "stylesheet", a.type = "text/css", a.onerror = a.onload = o => {
          if (a.onerror = a.onload = null, "load" === o.type) n();
          else {
            var i = o && ("load" === o.type ? "missing" : o.type),
              s = o && o.target && o.target.href || t,
              l = new Error("Loading CSS chunk " + e + " failed.\n(" + s + ")");
            l.code = "CSS_CHUNK_LOAD_FAILED", l.type = i, l.request = s, a.parentNode.removeChild(a), r(l)
          }
        }, a.href = t, document.head.appendChild(a)
      })(e, o, t, r)
    })),
      t = {
        179: 0
      };
    n.f.miniCss = (n, r) => {
      t[n] ? r.push(t[n]) : 0 !== t[n] && {
        226: 1,
        703: 1,
        718: 1
      }[n] && r.push(t[n] = e(n).then((() => {
        t[n] = 0
      }), (e => {
        throw delete t[n], e
      })))
    }
  })(), (() => {
    var e = {
      179: 0
    };
    n.f.j = (t, r) => {
      var a = n.o(e, t) ? e[t] : void 0;
      if (0 !== a)
        if (a) r.push(a[2]);
        else {
          var o = new Promise(((n, r) => a = e[t] = [n, r]));
          r.push(a[2] = o);
          var i = n.p + n.u(t),
            s = new Error;
          n.l(i, (r => {
            if (n.o(e, t) && (0 !== (a = e[t]) && (e[t] = void 0), a)) {
              var o = r && ("load" === r.type ? "missing" : r.type),
                i = r && r.target && r.target.src;
              s.message = "Loading chunk " + t + " failed.\n(" + o + ": " + i + ")", s.name = "ChunkLoadError", s.type = o, s.request = i, a[1](s)
            }
          }), "chunk-" + t, t)
        }
    };
    var t = (t, r) => {
      var a, o, [i, s, l] = r,
        d = 0;
      if (i.some((t => 0 !== e[t]))) {
        for (a in s) n.o(s, a) && (n.m[a] = s[a]);
        if (l) l(n)
      }
      for (t && t(r); d < i.length; d++) o = i[d], n.o(e, o) && e[o] && e[o][0](), e[o] = 0
    },
      r = self.webpackChunkdemel_shopify_template = self.webpackChunkdemel_shopify_template || [];
    r.forEach(t.bind(null, 0)), r.push = t.bind(null, r.push.bind(r))
  })(), n.nc = void 0, (() => {
    "use strict";
    n(4824);
    var e = n(9394),
      t = n(4412);

    function r() {
      const e = (0, t.go)(".js-accordion").filter((e => !e.hasAttribute("data-accordion-mq") || matchMedia(e.getAttribute("data-accordion-mq")).matches));
      e.length && async function (e) {
        const {
          default: t
        } = await n.e(209).then(n.bind(n, 8712));
        for (const n of e) new t(n)
      }(e)
    }

    function a() {
      const e = (0, t.U2)(".js-customer-addresses");
      e && n.e(835).then(n.bind(n, 8452)).then((({
        CustomerAddresses: t
      }) => {
        new t(e)
      }))
    }

    function o() {
      (0, t.U2)("propify-dialog") && n.e(226).then(n.bind(n, 1214))
    }
    var i = n(377),
      s = n.n(i);
    class l {
      constructor() {
        s().cfg.lazyClass = "js-lazyload", s().cfg.hFac = 0, s().cfg.loadMode = 1, s().cfg.minSize = 360, document.addEventListener("lazybeforesizes", (e => {
          e.detail.width = e.target.clientWidth || e.target.parentElement.clientWidth || e.detail.width
        }))
      }
    }

    function d() {
      (0, t.U2)("#app-instant-search") && Promise.all([n.e(928), n.e(718)]).then(n.bind(n, 1667))
    }

    function c() {
      !("/cart" === window.location.pathname) && (0, t.U2)("#app-minibasket") && Promise.all([n.e(928), n.e(703)]).then(n.bind(n, 6519))
    }
    const u = async (e, t) => n.e(309).then(n.bind(n, 5703)).then((({
      Slider: n
    }) => {
      new n(e, t)
    }));

    function f() {
      const e = (0, t.go)("[data-slider]:not(#insta-feed)");
      for (const t of e) {
        const e = JSON.parse(t.dataset.slider || "{}");
        e.enabled && u(t, e)
      }
    }
    window.initSlider = e => {
      const t = JSON.parse(e.dataset.slider || "{}");
      t.enabled && u(e, t)
    };
    const h = {
      html5: "HTML5",
      youtube: "YouTube",
      vimeo: "Vimeo"
    };
    const m = [function () {
      const e = (0, t.U2)(".js-header");
      e && (e => {
        Promise.all([n.e(647), n.e(19)]).then(n.bind(n, 1973)).then((({
          setup: t
        }) => t(e)))
      })(e), (0, t.U2)(".js-header-landing") && Promise.all([n.e(647), n.e(832)]).then(n.bind(n, 4310)).then((({
        setup: e
      }) => e()))
    }, () => (0, e.$e)(f), function () {
      new l
    }, function () {
      (0, t.U2)("lite-vimeo") && n.e(642).then(n.bind(n, 215));
      const e = (0, t.go)(".js-video");
      if (0 === e.length) return;
      const r = {
        html5: [],
        vimeo: [],
        youtube: []
      };
      for (const t of e) {
        const e = t.getAttribute("data-type");
        e && r[e].push(t)
      }
      Object.entries(r).forEach((async function ([e, t]) {
        if (0 === t.length) return;
        const {
          default: r
        } = await n(8131)(`./${h[e]}`);
        t.forEach((e => new r(e)))
      }))
    }, () => (0, e.$e)(a), () => (0, e.$e)(o), () => (0, e.$e)(r), function () {
      const e = (0, t.go)(".js-product-popup");
      e.length && (async e => {
        const {
          ProductPopup: t
        } = await n.e(900).then(n.bind(n, 8427));
        for (const n of e) new t(n)
      })(e), (0, t.U2)("variant-radios") && n.e(969).then(n.bind(n, 6339)), (0, t.U2)("product-form") && n.e(532).then(n.bind(n, 6956)), (0, t.U2)("product-personalization") && n.e(460).then(n.bind(n, 6544))
    }, () => (0, e.$e)(d), () => (0, e.$e)(c), function () {
      const e = (0, t.go)(".js-tabs");
      e.length && async function (e) {
        const {
          default: t
        } = await n.e(520).then(n.bind(n, 6493));
        for (const n of e) new t(n)
      }(e)
    }, function () {
      const e = (0, t.go)(".js-smooth-scroll");
      e.length && (e => {
        n.e(628).then(n.bind(n, 1814)).then((({
          setup: t
        }) => t(e)))
      })(e)
    }];
    for (const e of m) e();
    ["theme"].map((e => n(2092)(`./${e}`)))
  })()
})();



class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    if( this.elements.button ) {
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    }
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define('localization-form', LocalizationForm);



const resizeObserver = new ResizeObserver(function(entries){ 
  if( window.scrollerElement ) {
    window.scrollerElement.update();
  } else {
    window.dispatchEvent(new Event('resize'));
  }
})
resizeObserver.observe(document.body)


document.addEventListener('DOMContentLoaded', function(){
  if( typeof(FilterResult) !== 'undefined' ) {
    FilterResult.prototype.afterRender = function() {  
      document.body.classList.add('filter-result--loaded');
  
      var sortBtn = document.querySelector('.boost-pfs-filter-custom-sorting');
      if( sortBtn ){
        sortBtn.addEventListener('click', function(){
          document.body.classList.remove('boost-pfs-filter-tree-open-body');
        });
      }
    }
  }
  
});

document.addEventListener('DOMContentLoaded', () => {
  // fetch(
  //   window.Shopify.routes.root
  //     + 'browsing_context_suggestions.json'
  //     + '?country[enabled]=true'
  //     + `&country[exclude]=${window.Shopify.country}`
  //     + '&language[enabled]=true'
  //     + `&language[exclude]=${window.Shopify.language}`
  // ).then(async (r) => await r.json()).then(countries => {
  //   const formId = 'language-form-auto'
  //   if (countries && countries.suggestions.length > 0) {
  //     const country = countries.suggestions[0].parts.country.handle
  //     const language = countries.suggestions[0].parts.country.handle === 'CH' || countries.suggestions[0].parts.country.handle === 'AT' || countries.suggestions[0].parts.country.handle === 'DE' ? 'DE' : 'EN'
  //     const formHtml = `
  //       <form id="${formId}" action="/localization" method="POST" hidden>
  //         <input name="_method" value="PUT">
  //         <input name="country_code" value="${country}">
  //         <input name="language_code" value="${language}">
  //       </form>
  //     `;
  //     document.querySelector('.scroll-container').insertAdjacentHTML("beforeend", formHtml);
  //     // document.getElementById(formId).submit();
  //   }
  // });

  function getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    }
    
  function setDefaultLanguage(lang){
    const YOUR_DOMAIN = window.location.origin
    const YOUR_DOMAIN_LENGTH = YOUR_DOMAIN.length
    const LANGUAGE_COOKIE_NAME = "language"
    let selectedLanguage = getCookie(LANGUAGE_COOKIE_NAME)
    if (!selectedLanguage || selectedLanguage !== lang) {
      document.cookie = `${LANGUAGE_COOKIE_NAME}=${lang};`;
      if (!window.location.href.includes(`${YOUR_DOMAIN}/${lang}`)){
        var url = window.location.href;
        var redirect_url = url.slice(0, YOUR_DOMAIN_LENGTH) + `/${lang}` + url.slice(YOUR_DOMAIN_LENGTH);
        window.location.href= redirect_url;
        const form = document.getElementById("localization_form")
        form.querySelector('input[name="language_code"]').value = lang
        form.submit()
      }
    }
  }

  let globalLanguage = null;
  
  fetch(
    window.Shopify.routes.root
      + 'browsing_context_suggestions.json'
      + '?country[enabled]=true'
      + `&country[exclude]=${window.Shopify.country}`
      + '&language[enabled]=true'
      + `&language[exclude]=${window.Shopify.language}`
  ).then(async (r) => await r.json()).then(countries => {
    const formId = 'language-form-auto'
    if (countries && countries.suggestions.length > 0) {
      const country = countries.suggestions[0].parts.country.handle
      const language = countries.suggestions[0].parts.country.handle === 'CH' || countries.suggestions[0].parts.country.handle === 'AT' || countries.suggestions[0].parts.country.handle === 'DE' ? 'DE' : 'EN'

      if (window.location.origin !== 'https://demel-wien.myshopify.com') {
        setDefaultLanguage(language)
        globalLanguage = language
      }
    }
  })

  document.getElementById('download-terms')?.addEventListener('click', () => {
    if (window.location.href.includes('/en/')) {
      window.open('https://cdn.shopify.com/s/files/1/0557/0943/3946/files/Demel_s_Term_of_Use_-_English_1.pdf?v=1718364647', '_blank').focus()
    } else {
      window.open('https://cdn.shopify.com/s/files/1/0557/0943/3946/files/Demel_s_Term_of_Use_-_German_1.pdf?v=1718364646', '_blank').focus()
    }
  })

})
